module.exports = __webpack_public_path__ + "static/ui-3-f285e774da18e496f7f3ca5d52582dab.png";